import Random from 'random-js';
const random = Random();

const MIN_SYMBOLS_LENGTH = 8;

export default class SecretSymbols {
  constructor(options) {
    const {
      rootEl,
      word,
      symbols,
      duration,
      renderType,
    } = options;

    this.rootEl = rootEl;
    this.word = word;
    this.symbols = this.symbolsStrToArr(symbols);
    this.duration = duration || 50;
    this.renderType = renderType;
    this.isRevealed = false;

    this.render();
  }

  symbolsStrToArr(symbolsStr) {
    const arr = [];
    for (let i = 0, len = symbolsStr.length; i < len; i += 1) {
      arr.push(symbolsStr[i]);
    }
    return arr;
  }

  render = () => {
    if (this.isRevealed) {
      this.renderReveleadSymbols();
      return;
    }
    setTimeout(() => {
      if (random.bool(0.8)) {
        if (this.renderType === 'date') {
          this.renderSymbolsDate();
        }
        else if (this.renderType === 'time') {
          this.renderSymbolsTime();
        }
        else {
          this.renderSymbols();
        }
      }
      else {
        this.renderSymbols();
      }

      this.render();
    }, random.integer(100, 500));
  }

  renderSymbols() {
    const {
      rootEl,
      symbols,
      word,
    } = this;
    let secret = '';
    const len = Math.max(word.length, MIN_SYMBOLS_LENGTH);
    for (let i = 0; i < len; i += 1) {
      secret += random.pick(symbols);
    }
    rootEl.innerText = secret;
  }

  renderSymbolsDate() {
    const {
      rootEl,
      symbols,
      word,
    } = this;
    let secret = '';

    const day = `${random.pick([1,2])}${random.pick([1,2,3,4,5,6,7,8,9,0])}`;
    const month = random.pick(['01','02','03','04','05','06','07','08','09',10,11,12]);
    const year = `20${random.pick([1,2])}${random.pick([6,7,8,9])}`;
    secret = `${day}.${month}.${year}`;

    rootEl.innerText = secret;
  }

  renderSymbolsTime() {
    const {
      rootEl,
      symbols,
      word,
    } = this;
    let secret = '';

    const h1 = random.integer(0,2);
    let h2;
    if (h1 < 2) {
      h2 = random.integer(0,9);
    } else {
      h2 = random.integer(0,3);
    }
    const m1 = random.integer(0,5);
    const m2 = random.integer(0,9);
    secret = `${h1}${h2}:${m1}${m2}`;

    rootEl.innerText = secret;
  }

  renderReveleadSymbols() {
    const {
      rootEl,
      word,
    } = this;
    rootEl.innerText = word;
  }

  reveal() {
    this.isRevealed = true;
  }
}



/** WEBPACK FOOTER **
 ** ./src/utils/SecretSymbols.js
 **/